const signalR = require('@aspnet/signalr');
import auth from '@/service/auth'
import Vue from 'vue';
import config from '../config'
export const EventBus = new Vue();

// const baseUrl = location.hostname == 'localhost' ? 'http://localhost:5100' : `${location.protocol}//${location.host}`;
// const baseUrl = location.hostname == 'localhost' ? 'http://10.0.0.66:5100' :'http://10.0.0.66:5100';

function getApiHost() {
  if(location.hostname == 'localhost') { return config.baseSignalR; }
  switch(process.env.NODE_ENV) {
    case 'development' : return config.baseSignalR;
    default : return `${location.protocol}//${location.hostname.replace(/^[^\\.]*\./, 'ws.')}`;
  }
}
const baseUrl = getApiHost();

let _connection = undefined;
let _retry = 0;

let start = (hub, close, fail) => {
  if(_connection && _connection.connectionState == signalR.HubConnectionState.Connected) { return rv; }
  if(!_connection) {
    _retry = 0;
    _connection = new signalR.HubConnectionBuilder()
      .withUrl(`${baseUrl}/${hub}`, { accessTokenFactory: () => auth.token, skipNegotiation: true, transport: signalR.HttpTransportType.WebSockets })
      .build();
  } else {
    if(_retry++ > 30) { if(fail && typeof(fail) === 'function') { fail(); } return rv; }
  }
  _connection.onclose(async () => { console.log('[svc] signalr', 'closed'); if(_connection) { setTimeout(() => start(hub), 500); if(close && typeof(close) === 'function') { close(); } } });
  if(_connection.connectionState == signalR.HubConnectionState.Disconnected) {
    _connection.start()
    .then(() => {
      console.log('[svc] signalr', 'connected')
      _retry = 0;
    })
    .catch(e => {
      console.log('[svc] signalr', 'err', e);
      setTimeout(() => start(hub), 1000);
    })
  }
  return rv;
}

let stop = () => { _connection && _connection.stop(); _connection = undefined; }
const rv = {
  on : (k, f) => { _connection &&_connection.on(k, f); return rv; },
  off : (k, f) => { _connection && _connection.off(k, f); return rv; },
  start : start,
  stop : stop,
  socket: () => _connection,
  subscribe: (key, func) => EventBus.$on(key, func),
  publish: (key, pl) => EventBus.$emit(key, pl)
};
export default rv

if(location.hostname == 'localhost') { window['signalr'] = rv; }
